import React, { useState, useEffect } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import { Button } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import update from "immutability-helper";
import { getDKDateTimeText } from "../../libs/dktime";

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default
        }
    }
}))(TableRow);

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: "100%"
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

export default props => {
    const classes = useStyles();
    const [dates, setDates] = useState([]);
    const [clickedDates, setClickedDates] = useState({});

    useEffect(() => {
        (async () => {
            setDates(props.course.dates);
            const clicked = [];
            props.course.dates.forEach(date => (clicked[date.id] = false));
            setClickedDates(clicked);
        })();
    }, [props.course.dates]);

    useEffect(() => {
        const result = [];
        dates.forEach(d => {
            if (clickedDates[d.id]) result.push(d.id);
        });
        props.handleCourseDateClick(result);
    }, [clickedDates]);

    return (
        <>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell></StyledTableCell>
                            <StyledTableCell>Dato</StyledTableCell>
                            <StyledTableCell align="right">Starttidspunkt</StyledTableCell>
                            <StyledTableCell align="right">Sluttidspunkt</StyledTableCell>
                            <StyledTableCell align="right">Bookede pladser</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dates.map((row, i) => {
                            //if (row.clients >= props.course.limit) return <></>;
                            return (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell>
                                        <Checkbox
                                            onClick={() =>{
                                                    setClickedDates(
                                                        update(clickedDates, { [row.id]: { $set: !clickedDates[row.id] } })
                                                    );
                                                }
                                            }
                                            checked={clickedDates[row.id]}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                        {moment(Number(row.from)).format("DD/MM/YYYY")}
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        <div style={{ minWidth: "120px" }}>
                                            {moment(Number(row.from)).format("HH:mm:ss")} <br />
                                            {getDKDateTimeText(Number(row.from))}
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        <div style={{ minWidth: "120px" }}>
                                            {moment(Number(row.to)).format("HH:mm:ss")}<br />
                                            {getDKDateTimeText(Number(row.to))}
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell align="right">{row.clients}/{props.course.limit}</StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* <Button onClick={props.handleBack} className={classes.button}>
                Tilbage
            </Button>
            <Button
                onClick={() => {
                    const result = [];
                    dates.forEach(d => {
                        if (clickedDates[d.id]) result.push(d.id);
                    });
                    props.handleCourseDateClick(result);
                    props.handleNext();
                }}
                className={classes.button}>
                Næste
            </Button> */}
        </>
    );
};
